<div class="spinner-wrapper" *ngIf="this.requestInProg$ | async">
  <div class="spinner-background"></div>
  <div class="spinner-box">
      <mat-progress-spinner class="spinner" color="accent" strokeWidth="5" diameter="100" mode="indeterminate"></mat-progress-spinner>
      <div class="spinner-message" [innerText]="'Updating Orders'"></div>
  </div>
</div>
<div class="container">
  <div class="upload-section">
    <h2>Upload Orders from CSV</h2>
    
    <!-- File Selection -->
    <div class="file-selection">
      <div class="file-input-wrapper">
        <input 
          type="file" 
          accept=".csv" 
          (change)="onFileSelected($event)" 
          [disabled]="isProcessing"
          #fileInput
          style="display: none;">
        <button 
          class="select-file-btn" 
          (click)="fileInput.click()" 
          [disabled]="isProcessing">
          {{ selectedFile ? 'Change File' : 'Select CSV File' }}
        </button>
        <span class="file-name" *ngIf="selectedFile">
          {{ selectedFile.name }}
        </span>
        <button 
          class="clear-btn" 
          (click)="clearFile()" 
          *ngIf="selectedFile"
          [disabled]="isProcessing">
          Clear
        </button>
      </div>
    </div>

    <!-- Processing Indicator -->
    <div class="processing-indicator" *ngIf="isProcessing">
      <div class="spinner"></div>
      <span>Processing file...</span>
    </div>

    <!-- Preview Section -->
    <div class="preview-section" *ngIf="previewResult && !isProcessing">
      <h3>File Preview</h3>
      
      <!-- Summary -->
      <div class="summary">
        <div class="summary-item">
          <span class="label">Total Orders:</span>
          <span class="value">{{ previewResult.totalOrders }}</span>
        </div>
        <div class="summary-item">
          <span class="label">Total Items:</span>
          <span class="value">{{ previewResult.totalItems }}</span>
        </div>
        <div class="summary-item">
          <span class="label">Status:</span>
          <span class="value" [class.error]="previewResult.hasErrors" [class.success]="!previewResult.hasErrors">
            {{ previewResult.hasErrors ? 'Errors Found' : 'Valid' }}
          </span>
        </div>
      </div>

      <!-- Upload Button -->
      <div class="upload-actions">
        <button 
          class="upload-btn" 
          (click)="onUpload()" 
          [disabled]="!uploadEnabled"
          [class.disabled]="!uploadEnabled">
          Upload Orders
        </button>
        <span class="upload-note" *ngIf="!uploadEnabled">
          Please fix all errors before uploading
        </span>
      </div>

      <!-- Error Details -->
      <div class="error-details" *ngIf="previewResult.hasErrors">
        <h4>Validation Errors</h4>
        <div class="error-list">
          <div 
            class="error-row" 
            *ngFor="let row of previewResult.rowsWithErrors" 
            [class.has-errors]="!row.isValid">
            <div class="row-header">
              <span class="line-number">Line {{ row.lineNumber }}:</span>
              <span class="row-data">{{ row.errors.join(', ') }}</span>
            </div>
            <div class="error-messages" *ngIf="!row.isValid">
              <div class="error-message" *ngFor="let error of row.errors">
                • {{ error }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Valid Rows Preview -->
      <div class="valid-rows" *ngIf="previewResult.totalOrders > 0">
        <h4>Valid Orders ({{ previewResult.totalOrders }})</h4>
        <div class="rows-preview">
          <div 
            class="valid-row" 
            *ngFor="let row of previewResult.rows.slice(0, 200)" 
            [class.has-errors]="!row.isValid">
            <span class="line-number-valid">Line {{ row.lineNumber }}:</span>
            <table *ngIf="groupItemPropertiesToRender(row.data) as rdata" class="keyvalue-table">
              <thead>
                <tr>
                  <th *ngFor="let kv of rdata | keyvalue : originalOrder" 
                    [ngClass]="{
                      wide: kv.key.toLowerCase().trim() === 'address' || kv.key.toLowerCase().trim() === 'order' || kv.key.toLowerCase().trim() === 'item details'
                    }"
                  >{{ kv.key | titlecase }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td *ngFor="let kv of rdata | keyvalue : originalOrder"
                    [ngClass]="{
                      wide: kv.key.toLowerCase().trim() === 'address' || kv.key.toLowerCase().trim() === 'order' || kv.key.toLowerCase().trim() === 'item details'
                    }"
                  >{{ kv.value }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="more-rows" *ngIf="previewResult.rows.length > 200">
            ... and {{ previewResult.rows.length - 200 }} more rows
          </div>
        </div>
      </div>
    </div>

  <!-- Instructions -->
  <div class="instructions" *ngIf="!selectedFile">
    <h3>Instructions</h3>
    <p>Upload a CSV file with the following columns in this exact order:</p>
    <ol>
      <li><strong>Dealer Name</strong> – Required</li>
      <li><strong>Order Number</strong> – Required</li>
      <li><strong>Invoice Number</strong> – Required</li>
      <li><strong>Invoice Date</strong> – Required</li>
      <li><strong>Shipping Date</strong> – Required</li>
      <li><strong>First Name</strong> – Required</li>
      <li><strong>Last Name</strong> – Required</li>
      <li><strong>Phone Number</strong> – Required</li>
      <li><strong>Street Name</strong> – Required</li>
      <li><strong>Street Number</strong> – Required</li>
      <li><strong>State</strong> – Required</li>
      <li><strong>Postal Code</strong> – Required</li>
      <li><strong>City</strong> – Required</li>
      <li><strong>Floor</strong> – Optional</li>
      <li><strong>Apartment</strong> – Optional</li>
      <li><strong>SKU</strong> – Required</li>
      <li><strong>Category</strong> – Required</li>
      <li><strong>Description</strong> – Optional</li>
      <li><strong>Quantity</strong> – Required, must be a positive integer</li>
      <li><strong>Service Type</strong> – Required</li>
      <li><strong>Serial Number</strong> – Optional</li>
      <li><strong>Vip</strong> – Optional</li>
      <li><strong>Service Description</strong> – Optional</li>
      <li><strong>Note</strong> – Optional</li>
    </ol>
    <p><strong>Note:</strong> The first row should contain headers and will be skipped during processing. Include all empty optional fields as empty values</p>
  </div>

  </div>
</div> 